// app/get-query-client.ts
import { QueryClient, defaultShouldDehydrateQuery, isServer } from '@tanstack/react-query';

function makeQueryClient() {
	return new QueryClient({
		defaultOptions: {
			queries: {
				refetchOnWindowFocus: false,
				retry: false,
				// With SSR, we usually want to set some default staleTime
				// above 0 to avoid refetching immediately on the client
				// TODO make above comment change when the app starts using server side queries
				staleTime: 0,
			},
			dehydrate: {
				// include pending and errored queries in dehydration. Errors must be
				// dehydrated so that pages relying on server-prefetched data (e.g.
				// /pricing) can surface their error UI on the client instead of the
				// client re-running the queryFn — which for prefetch-only hooks is a
				// throwing sentinel.
				shouldDehydrateQuery: (query) =>
					defaultShouldDehydrateQuery(query) ||
					query.state.status === 'pending' ||
					query.state.status === 'error',
			},
		},
	});
}

let browserQueryClient: QueryClient | undefined = undefined;

export const DEFAULT_STALE_TIME = 8 * 60 * 1000;

export function getQueryClient() {
	if (isServer) {
		// Server: always make a new query client
		return makeQueryClient();
	} else {
		// Browser: make a new query client if we don't already have one
		// This is very important, so we don't re-make a new client if React
		// suspends during the initial render. This may not be needed if we
		// have a suspense boundary BELOW the creation of the query client
		if (!browserQueryClient) browserQueryClient = makeQueryClient();
		browserQueryClient.setDefaultOptions({
			queries: {
				// staleTime: DEFAULT_STALE_TIME,
				refetchOnReconnect: false,
				refetchOnWindowFocus: false,
				retry: false,
				retryOnMount: false,
			},
		});
		return browserQueryClient;
	}
}
